// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"6da23af6","218":"efe4f1c6","240":"2708e247","261":"ad4f7626","333":"651d6836","355":"8c15f650","359":"c3da1a0c","390":"48368671","420":"7e4ff200","468":"5ca6e8a2","616":"cffd1a02","741":"ba985422","748":"d14c4793","787":"bab9baaf","922":"a25f730c"}[chunkId] + ".chunk.js";
};